// Hover dropdowns for desktop nav
if (window.innerWidth >= 990) {
  document.querySelectorAll('.header__inline-menu details').forEach((details) => {
    let closeTimer;

    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
      }, 150);
    });

    const submenu = details.querySelector('.header__submenu');
    if (submenu) {
      submenu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      submenu.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => details.removeAttribute('open'), 150);
      });
    }
  });
}
